import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NavigateDetailsState {
  navigateToTemplate: boolean;
}

const initialState: NavigateDetailsState = {
  navigateToTemplate: false
};

const navigateDetailsSlice = createSlice({
  name: "navigateDetails",
  initialState,
  reducers: {
    setNavigateToTemplate: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        navigateToTemplate: action.payload
      };
    },
    clearNavigateToTemplate: (state) => {
      return {
        ...initialState,
        navigateToTemplate: false
      };
    }
  }
});

export const { setNavigateToTemplate, clearNavigateToTemplate } =
  navigateDetailsSlice.actions;
export default navigateDetailsSlice.reducer;
